import { EffectiveRole, RolePermissionFlags, role } from 'auth-types';

const DEFAULT_PERMISSIONS: RolePermissionFlags = {
  perm_ai_tools: false,
  perm_course_view: false,
  perm_course_manage: false,
  perm_group_view: false,
  perm_group_manage: false,
  perm_group_analytics: false,
  perm_group_grade_edit: false,
  perm_subdomain_user_manage_students: false,
  perm_subdomain_user_manage_all_non_enterprise: false,
  perm_enterprise_exclusive: false,
};

const EffectiveRoleService = {
  getPermissions(effectiveRole: EffectiveRole | null | undefined): RolePermissionFlags {
    return effectiveRole?.permissions ?? DEFAULT_PERMISSIONS;
  },

  hasPermission(
    effectiveRole: EffectiveRole | null | undefined,
    permission: keyof RolePermissionFlags,
  ): boolean {
    const permissions = this.getPermissions(effectiveRole);
    return permissions[permission] === true;
  },

  deriveLegacyComparableRole(effectiveRole: EffectiveRole | null | undefined): role {
    if (!effectiveRole) {
      return '';
    }
    if (effectiveRole.roleType === 'student') {
      return 'student';
    }
    if (effectiveRole.permissions?.perm_enterprise_exclusive) {
      return 'enterprise_admin';
    }
    return 'instructor';
  },

  resolvePortalRoot(effectiveRole: EffectiveRole | null | undefined, fallbackRole: role): string {
    if (!effectiveRole) {
      return fallbackRole === 'student' ? '/student' : '/admin';
    }
    return effectiveRole.roleType === 'student' ? '/student' : '/admin';
  },
};

export default EffectiveRoleService;
